import { Component } from '@angular/core';
import { FAQsService } from '../../services/FAQs.service';
import { KeyAndValueModel } from '../../models/key-and-value.model';

@Component({
    selector: 'fa-qs',
    templateUrl: 'fa-qs.component.html',
    styleUrls: ['fa-qs.component.scss']
})
export class FaQsComponent {
  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true;
  data : KeyAndValueModel[]=[]
  constructor(private service:FAQsService) { }

  ngOnInit(): void {
    this.service.getAll()
    .subscribe(result=>{
        this.data = result;
    })
  }

}
